import React, { useState, useContext } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import {
  HeaderModal,
  ModalCancelamento,
  Body,
  FontButton,
} from "../styles/Emissao";
import TextField from "../../../../components/basics/TextFieldErp";
import useNfeController from "../controllers/NfeController";
import { PainelNfeContext } from "../contexts/PainelNfeContext";

const ModalCancelamentoNfe = ({
  modalCancelamentoOpen,
  setModalCancelamentoOpen,
  nfeId,
  hasSalesInNfe,
  setLoading = () => {},
  emissao = false,
  setNfeStatus = () => {},
}) => {
  const { handleCancelNfe } = useNfeController();
  const [reasonCancel, setReasonCancel] = useState("");

  const { saleSituation } = useContext(PainelNfeContext);

  const handleClose = () => {
    setModalCancelamentoOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={modalCancelamentoOpen}
      onClose={handleClose}
      aria-labelledby="dialog-cancelamento-nfe"
    >
      <ModalCancelamento>
        <HeaderModal>
          <DialogTitle id="dialog-cancelamento-nfe">
            <Chip
              label="Cancelamento da NFe"
              bgcolor="primary"
              textcolor="white"
            />
          </DialogTitle>
        </HeaderModal>
        <DialogContent>
          <Body>
            {/*DESABILITADO ESTA FUNÇÃO PARA O USUARIO N SELECIONAR O TIPO DA SITUAÇÃO E SIM O SISTEMA UTILZIAR O CADASTRADO*/}
            {/* <Grid container spacing={2}>
              {hasSalesInNfe && <SelectSituacaoDeVenda />}
            </Grid> */}
            <Grid container spacing={2}>
              <Grid item xs>
                <TextField
                  label="Motivo de Cancelamento"
                  value={reasonCancel}
                  setValue={setReasonCancel}
                  variant="filled"
                  multiline
                  rows={6}
                />
              </Grid>
            </Grid>
          </Body>
        </DialogContent>
        <DialogActions>
          <FontButton>
            <Grid container spacing={2}>
              <Grid item xs />
              <Grid item>
                <Btn
                  bgcolor="tertiary"
                  hovercolor="blue"
                  onClick={handleClose}
                  label="Cancelar Ação"
                  full="true"
                />
              </Grid>
              <Grid item>
                <Btn
                  label="Confirmar Cancelamento"
                  full="true"
                  disabled={reasonCancel.length < 15}
                  onClick={() =>
                    handleCancelNfe(
                      nfeId,
                      reasonCancel,
                      { hasSalesInNfe, saleSituation },
                      emissao,
                      setLoading,
                      setNfeStatus,
                      setModalCancelamentoOpen
                    )
                  }
                />
              </Grid>
            </Grid>
          </FontButton>
        </DialogActions>
      </ModalCancelamento>
    </Dialog>
  );
};

export default ModalCancelamentoNfe;
